export const rules = {
    time: [
        { required: true, message: 'Пожалуйста, введите время ', trigger: 'blur' },
    ],
};
